import { PERMISSION_ASKED_STORAGE_KEY, MAX_ASK_PERMISSION, MAX_TIME_PERMISSION_ASKED, NOTIFICATIONS_SUBSCRIPTION_ID, REJECT_NOTIFICATIONS_STORAGE_KEY } from './constants';
import { isArray, isString } from 'lodash';

export function canAskPermission() {
    if (isNotificationsRejected()) {
        return false;
    }

    let permissionAsked;
    try {
        permissionAsked = JSON.parse(localStorage.getItem(PERMISSION_ASKED_STORAGE_KEY)) ?? [];
    } catch (e) {
        permissionAsked = [];
    }

    if (!isArray(permissionAsked)) {
        permissionAsked = [];
    }

    // Map entries to date object
    permissionAsked = permissionAsked.map((ts) => new Date(ts));

    // Filter out invalid entries
    permissionAsked = permissionAsked.filter((ts) => !!ts.valueOf());

    // Filter out old entries
    let now = new Date().valueOf();
    permissionAsked = permissionAsked.filter((ts) => ts.valueOf() - now < MAX_TIME_PERMISSION_ASKED);

    return permissionAsked.length < MAX_ASK_PERMISSION;
}

export function registerPermissionRequest() {
    let permissionAsked = localStorage.getItem(PERMISSION_ASKED_STORAGE_KEY) ?? [];

    if (!isArray(permissionAsked)) {
        permissionAsked = [];
    }

    // Register new timestamp
    permissionAsked.push(new Date().toISOString());

    // Save to localStorage
    localStorage.setItem(PERMISSION_ASKED_STORAGE_KEY, JSON.stringify(permissionAsked));
}

export function storeSubscriptionId(subscriptionId) {
    localStorage.setItem(NOTIFICATIONS_SUBSCRIPTION_ID, subscriptionId);
}

export function removeSubscriptionId() {
    localStorage.removeItem(NOTIFICATIONS_SUBSCRIPTION_ID);
}

export function isSubscribed() {
    return !!localStorage.getItem(NOTIFICATIONS_SUBSCRIPTION_ID);
}

export function getSubscriptionId() {
    return localStorage.getItem(NOTIFICATIONS_SUBSCRIPTION_ID)
}

export function setNotificationsRejected(rejected) {
    localStorage.setItem(REJECT_NOTIFICATIONS_STORAGE_KEY, JSON.stringify(rejected));
}

export function isNotificationsRejected() {
    let rejected = localStorage.getItem(REJECT_NOTIFICATIONS_STORAGE_KEY);
    if (isString(rejected)) {
        rejected = JSON.parse(rejected);
    }
    return rejected;
}
